import React from 'react';

import { CODE_FONT_STYLE } from '../../CodeBlock/CodeBlock';

/**
 * Whenever the `environment` custom function argument is mentioned in a message, use this component to render it as inline code.
 * In messages.ts, this is used like this: "Environment variables and secrets are passed through the {Environment} argument."
 */
export const Environment = (
  <span
    style={{
      ...CODE_FONT_STYLE,
    }}
  >
    {/* Do not internationalize. This is a literal argument */}
    environment
  </span>
);
